import { render, staticRenderFns } from "./DeleteAnswer.vue?vue&type=template&id=5a0e53b8&scoped=true&"
import script from "./DeleteAnswer.vue?vue&type=script&lang=js&"
export * from "./DeleteAnswer.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAnswer.vue?vue&type=style&index=0&id=5a0e53b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0e53b8",
  null
  
)

export default component.exports